import AWS from 'aws-sdk';

const wasabiEndpoint = 'https://s3.us-central-1.wasabisys.com';
const accessKeyId = 'Y0WWU13PSR9JMDUASN8V';
const secretAccessKey = 'DF7tATk9SPB0aGkf8tzXkYcfHaBhl2BQzp3hRcm1';

// Configure AWS SDK
AWS.config.update({
  accessKeyId: accessKeyId,
  secretAccessKey: secretAccessKey,
  region: 'us-central-1'
});

const s3 = new AWS.S3({
  endpoint: wasabiEndpoint,
  s3ForcePathStyle: true,
  signatureVersion: 'v4',
  region: 'us-central-1'
});

export default s3;